const constants = {
  title: "Cupones",
  searchPlaceholder: "Buscar por negocio...",
  createStore: "Crear cupón",
  showExpired: "Mostrar vencidos",
};

export default constants;
